<div class="bg-m0 flex select-none flex-col p-9">
  <div class="flex flex-col justify-start">
    <div
      data-cy="chartsAddFilterDialogTitle"
      class="text-s2 mt-5 text-left text-2xl font-semibold"
      >Row - Add Filter</div
    >

    <div class="flex flex-col">
      <div
        class="mt-9 flex min-w-[2px] max-w-[1000px] flex-grow select-none flex-row items-start"
      >
        <form
          [formGroup]="addFilterForm"
          class="min-w-[2px] max-w-[800px] flex-grow"
        >
          <ng-select
            #rowAddFilterSelect
            [fixNgSelectBottom]="rowAddFilterSelect"
            data-cy="rowAddFilterSelect"
            class="charts-add-column-select w-full min-w-[2px] text-base"
            [items]="sortedFieldsY"
            [loading]="modelLoading"
            [clearable]="false"
            [searchable]="true"
            [searchFn]="searchFn"
            [(ngModel)]="newFieldId"
            (change)="fieldChange()"
            (keyup.esc)="
              $event.stopImmediatePropagation(); rowAddFilterSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation(); rowAddFilterSelect.blur()
            "
            appendTo="body"
            placeholder="Select Field"
            formControlName="field"
            bindLabel="partLabel"
            bindValue="id"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="ml-1 flex flex-row items-center">
                <m-field-result
                  class="h-5 w-5"
                  [size]="2"
                  [fieldClass]="item.fieldClass"
                  [result]="item.result"
                ></m-field-result>

                <m-field-label
                  [column]="item"
                  class="ml-3 flex"
                ></m-field-label>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="ml-1 flex flex-row items-center">
                <m-field-result
                  class="h-5 w-5"
                  [size]="2"
                  [fieldClass]="item.fieldClass"
                  [result]="item.result"
                ></m-field-result>

                <m-field-label
                  [column]="item"
                  class="ml-3 flex"
                ></m-field-label>
              </div>
            </ng-template>
          </ng-select>
        </form>
      </div>
    </div>
  </div>

  <div class="mt-14 flex flex-row items-center">
    <ng-template #templateAddFilter>
      <div *ngIf="isFieldAlreadyFiltered === true"
        >This field is already filtered</div
      >
    </ng-template>

    <div
      class="flex"
      [tpIsEnabled]="isFieldAlreadyFiltered === true"
      [tp]="templateAddFilter"
    >
      <button
        data-cy="chartsAddFilterDialogSaveButton"
        class="bg-m600 text-m0 w-28 select-none rounded py-3 text-base font-medium focus:outline-none"
        [ngClass]="{
          'bg-m600': isFieldAlreadyFiltered === false,
          'bg-s400 cursor-default': isFieldAlreadyFiltered === true
        }"
        type="button"
        (click)="save()"
        [disabled]="isFieldAlreadyFiltered === true"
        >Add</button
      >
    </div>

    <button
      data-cy="chartsAddFilterDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
